import { render, staticRenderFns } from "./EditIsWin.vue?vue&type=template&id=0a577852&scoped=true&"
import script from "./EditIsWin.vue?vue&type=script&lang=js&"
export * from "./EditIsWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a577852",
  null
  
)

export default component.exports